import React, { Component } from 'react';
import { Button, Drawer, message, Table } from 'antd';
import { queryAddWorkOrg, queryDeleteWorkOrg, queryWorkOrgList } from '@api/hr/workOrg';
import FormWorkorg from './FormWorkorg';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      pageNo: 1,
      condition: '',
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadData('', 1);
  }

  handleSave = params => {
    this.saveWorkorg(params);
  };

  saveWorkorg = params => {
    queryAddWorkOrg(params).then(res => {
      if (res.statusCode === 200) {
        this.handleVisible(false);
        message.success(res.message);
        this.loadData(this.state.condition, this.state.pageNo);
      } else {
        message.error(res.message);
      }
    });
  };

  deleteWorkorg = uuid => {
    const { condition, pageNo } = this.state;
    queryDeleteWorkOrg({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.loadData(condition, pageNo);
      } else {
        message.error(res.message);
      }
    });
  };

  loadData = (condition, pageNo) => {
    const params = {};
    const { pageNo: no } = this.state;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    queryWorkOrgList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({ data: res.data, total: res.totalSize, pageNo, condition });
      } else {
        message.error(res.message);
      }
    });
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleAdd = detail => {
    this.setState({
      detail,
    });
    this.handleVisible(true);
  };

  handleEdit = record => {
    this.setState({
      detail: record,
    });
    this.handleVisible(true);
  };

  columns = () => [
    {
      title: '业务部门名称',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => <a onClick={() => this.handleEdit(record)}>{text}</a>,
    },

    {
      title: '人员数量',
      dataIndex: 'count',
      key: 'count',
    },
    {
      title: '操作',
      key: 'done',
      render: (rext, record) => (
        <span>
          <a onClick={() => this.handleEdit(record)}>修改</a>
          <span className="ant-divider" />
          <a onClick={() => this.deleteWorkorg(record.uuid)}>删除</a>
        </span>
      ),
    },
  ];

  setClassName = (record, index) => {
    if (record.status === 0) {
      return 'td-gray';
    }
  };

  render() {
    const { total, condition, visible, detail, data, pageNo } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.loadData(condition, current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <div>
        <Button
          type="primary"
          icon="plus"
          style={{ marginBottom: 15 }}
          onClick={() => {
            this.handleAdd({});
          }}
        >
          添加
        </Button>
        <Table
          style={{ background: '#fff' }}
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
          rowKey="uuid"
          rowClassName={this.setClassName}
        />
        {visible ? (
          <Drawer
            title={detail.uuid ? '业务部门编辑' : '业务部门新增'}
            placement="right"
            closable
            visible={visible}
            onClose={() => {
              this.handleVisible(false);
              this.loadData(condition, pageNo);
            }}
            width={680}
          >
            <FormWorkorg onSubmit={this.handleSave} detail={detail} />
          </Drawer>
        ) : null}
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/hr/workorg/Index.js